import { toast } from 'react-toastify';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getFormularyDetails } from '../../../utilities/API/applicationSubmitServices';

export const formularyDetails = createAsyncThunk(
    'formulary', getFormularyDetails
)

const initialState = {
    value: []
}

const formularyDetailsSlice = createSlice({
    name: 'formularyData',
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(formularyDetails.pending, (state, action) => {
                // toast.warn("PreQualQuestions pending")
            })
            .addCase(formularyDetails.fulfilled, (state, action) => {
            })
            .addCase(formularyDetails.rejected, (state, action) => {
                // toast.error(action.error.message)
            })
    },
})


export default formularyDetailsSlice.reducer